import { 
    IMinCostPerSquareFootVersionController 
} from '../Interfaces/ControllerInterfacesBarrel';

import {
    MinCostPerSquareFootVersionRequest,
    MinCostPerSquareFootVersionResponse,
} from "@app/models/api";

export default class MockMinCostPerSquareFootVersionController implements IMinCostPerSquareFootVersionController {
    public constructor() {      
    }

    public async getAllMinCostPerSquareFootVersions(): Promise<MinCostPerSquareFootVersionResponse[]> {
        throw new Error("Method not implemented.");
    }

    public async getMinCostPerSquareFootVersion(versionId: number): Promise<MinCostPerSquareFootVersionResponse> {
        throw new Error("Method not implemented.");
    }

    public async addMinCostPerSquareFootVersion(minCostPerSquareFootVersion: MinCostPerSquareFootVersionRequest): Promise<MinCostPerSquareFootVersionResponse> {
        throw new Error("Method not implemented.");
    }

    public async deleteMinCostPerSquareFootVersion(versionId: number): Promise<void> {
        throw new Error("Method not implemented.");
    }

    public async updateMinCostPerSquareFootVersion(versionId: number, minCostPerSquareFootVersion: MinCostPerSquareFootVersionRequest): Promise<MinCostPerSquareFootVersionResponse> {
        throw new Error("Method not implemented.");
    }

    public async completeMinCostPerSquareFootVersion(versionId: number): Promise<MinCostPerSquareFootVersionResponse> {
        throw new Error("Method not implemented.");
    }
};